import React from 'react';
import './HeroAtmosphere.css';

/** A short, decorative entrance; no perpetual animation or input interception. */
export default function HeroAtmosphere() {
  return <div className="hero-atmosphere" aria-hidden="true"><i /><i /></div>;
}
